export default __webpack_public_path__ + "static/media/09n.b96fb295.png";